import type { CategoryGroup } from '../schemas/catalog.schema'

export type CategoryCode = {
  code: string
  name: string
  group: CategoryGroup
  keywords: string[]
}

export const CATEGORY_GROUPS: {
  id: CategoryGroup
  name: string
  hint: string
}[] = [
  {
    id: 'charge',
    name: '충전구·충전포트',
    hint: '충전구 커버, 완속 커버, 충전포트 플랩',
  },
  { id: 'interior', name: '차량 인테리어·편의', hint: '수납함, 트렁크 손잡이' },
  { id: 'parts', name: '부속품', hint: '오링 등 소모·부속품' },
  { id: 'etc', name: '기타·리퍼', hint: 'B급·혼합·리퍼 상품' },
]

export const CATEGORY_CODES: CategoryCode[] = [
  {
    code: 'charge-cover',
    name: '충전구 커버',
    group: 'charge',
    keywords: ['충전구 커버', '충전구 뚜껑'],
  },
  {
    code: 'slow-cover',
    name: '완속 충전구 커버',
    group: 'charge',
    keywords: ['완속'],
  },
  {
    code: 'port-flap',
    name: '충전포트 플랩',
    group: 'charge',
    keywords: ['플랩', '폴스타'],
  },
  {
    code: 'universal-port',
    name: '범용 충전구 부품',
    group: 'charge',
    keywords: ['전차종', '범용', '경첩형'],
  },
  {
    code: 'trunk-handle',
    name: '트렁크 손잡이',
    group: 'interior',
    keywords: ['트렁크', '손잡이'],
  },
  {
    code: 'console-storage',
    name: '센터콘솔 수납',
    group: 'interior',
    keywords: ['센터콘솔', '트레이'],
  },
  {
    code: 'adapter-storage',
    name: '충전 어댑터 수납',
    group: 'interior',
    keywords: ['어댑터', '수납함'],
  },
  {
    code: 'cover-parts',
    name: '충전구 커버 부속품',
    group: 'parts',
    keywords: ['오링', 'O링', '실리콘'],
  },
  {
    code: 'refurb',
    name: 'B급/리퍼',
    group: 'etc',
    keywords: ['B급', '리퍼', '혼합'],
  },
]

export function getCategoryCode(code: string | null) {
  return CATEGORY_CODES.find((item) => item.code === code) ?? null
}

export function getCategoryGroup(id: string | null) {
  return CATEGORY_GROUPS.find((item) => item.id === id) ?? null
}

export const SHARED_VEHICLE_ID = 'all'
